import React from 'react';

import { ButtonBase, Typography } from '@material-ui/core';

import { Container } from './styles';

const ButtonItem = ({ children, icon, disabled, active, ...rest }) => {
  return (
    <Container disabled={disabled} active={active}>
      <ButtonBase {...rest} disabled={disabled}>
        <div id="icon">{icon}</div>

        <div id="text">
          <Typography>{children}</Typography>
        </div>
      </ButtonBase>
    </Container>
  );
};

export default ButtonItem;
